// Global constants
const ZODIAC_RADIOS_SELECTOR = '.SizeSwatch__Radio';
const CHECKBOX_PARENT_SELECTOR = '.bold_option_value_element';
const PO_MESSAGE_SELECTOR = '.backorder';
const FINAL_SELECTOR = '.zodiac_final_price';
const ADD_TO_CART_BUTTON_SELECTOR = '.ProductForm__AddToCart.bold_clone';
const PRODUCT_BUTTON_SELECTOR = '.ProductForm__AddToCart.bold_clone span';
const PRODUCT_JSON_SELECTOR = '[data-product-json]';
const ZODIAC_FINAL_SALE_SELECTOR = '.zodiac_final_sale';

let currentVariantId = null;

document.addEventListener('DOMContentLoaded', function() {
    // Call the function to add HTML content
    addZodiacHtmlContent();

    // After the entire page is loaded, execute events with delays
    setTimeout(function() {
        setupEventListeners();  // Setup event listeners

        setTimeout(function() {
            processPageState();  // Process the page state
        }, 250);

        setTimeout(function() {
            handleMultiVariant();  // Manually trigger handleMultiVariant to force a state update
        }, 500); // 250ms + 250ms = 500ms delay

    }, 250); // Initial 250ms delay
});

document.addEventListener('variant:changed', function(event) {
    const variant = event.detail.variant;
    
    // Dynamic variables based on variant
    const po_message = document.querySelector(PO_MESSAGE_SELECTOR);
    const addToCartButton = document.querySelector(ADD_TO_CART_BUTTON_SELECTOR);
    const productButton = document.querySelector(PRODUCT_BUTTON_SELECTOR);
    const zodiacFinalSale = document.querySelector(ZODIAC_FINAL_SALE_SELECTOR);
    const cap = po_cap_qty_js; // Assuming po_cap_qty_js is globally available
    const fs_input = document.querySelector('.final_sale_property');

    const jsonData = JSON.parse(document.querySelector(PRODUCT_JSON_SELECTOR).innerHTML);
    const variantsInventories = jsonData['inventories'] || {};
    const qty = variantsInventories[variant.id].inventory_quantity;

    const today = new Date();
    const multiplier = 7 * 24 * 60 * 60 * 1000; 
    const lead_3 = new Date(today.getTime() + 3 * multiplier);
    const lead_8 = new Date(today.getTime() + 8 * multiplier);
    const lead_11 = new Date(today.getTime() + 11 * multiplier);
    const lead_3_formatted = 'Custom Order. Ships: ' + lead_3.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    const lead_8_formatted = 'Back Order. Available: ' + lead_8.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    const lead_11_formatted = 'Back Order. Available: ' + lead_11.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });

    

    if (variant.available) {
        if (qty < 1 && qty >= cap) {
            // IN PO RANGE      
            if (variant.title === 'Multiple Signs') {
              po_message.innerText = lead_11_formatted;
              zodiacFinalSale.style.display = '';
              fs_input.name = 'properties[_Final Sale]';
              fs_input.value = 'Final Sale';          
            } else {
              po_message.innerText = lead_8_formatted;
              zodiacFinalSale.style.display = 'none';
              fs_input.name = '';
              fs_input.value = '';              
              enableAddToCartButton(addToCartButton);
            }
            productButton.innerText = 'Back Order';
            enableAddToCartButton(addToCartButton);              
        } else if (qty < cap) {
            // BELOW CAP          
            po_message.innerText = '';
            productButton.innerText = 'Sold Out';
            disableAddToCartButton(addToCartButton);
            zodiacFinalSale.style.display = 'none';
            fs_input.name = '';
            fs_input.value = '';          
        } else {
            // IN STOCK       
            if (variant.title === 'Multiple Signs') {
              po_message.innerText = lead_3_formatted;
              zodiacFinalSale.style.display = '';
              fs_input_input.name = 'properties[_Final Sale]';
              fs_input.value = 'Final Sale';                   
            } else {
              po_message.innerText = ''; 
              zodiacFinalSale.style.display = 'none';
              fs_input.name = '';
              fs_input.value = '';  
              enableAddToCartButton(addToCartButton);
            }
            productButton.innerText = 'Add To Cart';
            enableAddToCartButton(addToCartButton);             
        }
    } else {
        // SOLD OUT
        po_message.innerText = '';
        productButton.innerText = 'Sold Out';
        disableAddToCartButton(addToCartButton);
        zodiacFinalSale.style.display = 'none';
        fs_input.name = '';
        fs_input.value = '';  
    }
    
    processPageState();
});

function addZodiacHtmlContent() {
    var zodiacHtml = `
        <span>Choose at least two signs:</span>
        <ul class='zodiac_details'>
            <li>Custom necklaces are final sale and not returnable.</li>
            <li>Please allow additional 3 weeks for delivery.</li>
        </ul>
    `;

    // Get the element with class 'bold_option_title'
    var targetElement = document.querySelector('.bold_option_title');

    if (targetElement) {
        // Create a container for our HTML
        var divContainer = document.createElement('div');
        divContainer.className = 'zodiac_details'; // Assigning the class to the container
        divContainer.innerHTML = zodiacHtml;
        // Insert the entire container after the targetElement
        targetElement.parentNode.insertBefore(divContainer, targetElement.nextSibling);
    }
}

function setupEventListeners() {
    const zodiacRadios = document.querySelectorAll(ZODIAC_RADIOS_SELECTOR);
    zodiacRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            handleConditions();
            processPageState();
        });
    });

    const checkboxParents = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR);
    checkboxParents.forEach(parent => {
        const checkbox = parent.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.addEventListener('change', () => {
                handleConditions();
                processPageState();
            });
        }
    });
}

function processPageState() {
    handleMultiVariant();
    updateCheckboxState();
}

function handleConditions() {
    const checkboxParents = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR);
    checkboxParents.forEach(parent => {
        const checkbox = parent.querySelector('input[type="checkbox"]');
        const label = parent.parentElement.parentElement.querySelector('label');
        if (checkbox.checked) {
            label.classList.add('selected-label');
        } else {
            label.classList.remove('selected-label');
        }
    });
}

function isMultiVariantSelected() {
    const selectedZodiac = document.querySelector('.SizeSwatch__Radio:checked');
    return selectedZodiac && selectedZodiac.value === 'Multiple Signs';
}

function updateCheckboxState() {
    const zodiacFinalSale = document.querySelector(ZODIAC_FINAL_SALE_SELECTOR);
    if (isMultiVariantSelected()) {
        handleMultiVariant();
        enableCheckboxes(); 
        zodiacFinalSale.style.display = ''; // Show the final sale message
    } else {
        uncheckAllBoxes();
        disableCheckboxes(); 
        zodiacFinalSale.style.display = 'none'; // Hide the final sale message
    }
    handleConditions();
}

function countCheckedCheckboxes() {
    const checkboxes = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR + ' input[type="checkbox"]:checked');
    return checkboxes.length;
}

function handleMultiVariant() {
    const numChecked = countCheckedCheckboxes();
    console.log("Number of checkboxes checked:", numChecked);

    const addToCartButton = document.querySelector(ADD_TO_CART_BUTTON_SELECTOR);
    const productButton = document.querySelector(PRODUCT_BUTTON_SELECTOR);
    const boldOptionsElement = document.querySelector('.bold_options'); // Select the .bold_options element
    const final = document.querySelector(FINAL_SELECTOR);

    // Get the base price from the data attribute
    const basePriceElement = document.getElementById('variant-price');
    let basePrice = 215; // Default value
    if (basePriceElement && !isNaN(parseFloat(basePriceElement.getAttribute('data-price')))) {
        basePrice = parseFloat(basePriceElement.getAttribute('data-price'));
    }

    if (isMultiVariantSelected()) {
        if (numChecked >= 2) {
            enableAddToCartButton(addToCartButton);
            const total = (numChecked * 45) + basePrice;
            final.innerText = `Total Price: $${total.toFixed(0)}`;  // Ensure 2 decimal places
            final.classList.remove('zodiac_hidden');
        } else {
            disableAddToCartButton(addToCartButton);
            final.innerText = '';
            final.classList.add('zodiac_hidden');
        }
        boldOptionsElement.classList.remove('zodiac_hidden');
        final.classList.remove('zodiac_hidden');
    } else {
        enableAddToCartButton(addToCartButton);
        boldOptionsElement.classList.add('zodiac_hidden');
        final.classList.add('zodiac_hidden');
    }
}

function uncheckAllBoxes() {
    const checkboxParents = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR);
    checkboxParents.forEach(parent => {
        const checkbox = parent.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            const label = parent.parentElement.parentElement.querySelector('label');
            label.classList.remove('selected-label');
        }
    });
}

function enableCheckboxes() {
    const checkboxParents = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR);
    checkboxParents.forEach(parent => {
        const checkbox = parent.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.removeAttribute('disabled');
        }
    });
}

function disableCheckboxes() {
    const checkboxParents = document.querySelectorAll(CHECKBOX_PARENT_SELECTOR);
    checkboxParents.forEach(parent => {
        const checkbox = parent.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.setAttribute('disabled', 'true');
        }
    });
}

function enableAddToCartButton(button) {
    button.removeAttribute('disabled');
    button.classList.remove('Button--secondary', 'zodiac_button');
}

function disableAddToCartButton(button) {
    button.setAttribute('disabled', 'disabled');
    button.classList.add('Button--secondary', 'zodiac_button');
}
